import { LOCALES } from "../locales";

export default {
  [LOCALES.PORTUGESE]: {
    // general product translation
    January: "janeiro",
    February: "fevereiro",
    March: "março",
    April: "abril",
    May: "maio",
    June: "junho",
    July: "julho",
    August: "agosto",
    September: "setembro",
    October: "outubro",
    November: "novembro",
    December: "dezembro",

    class_policy: "Política da Classe",
    Faq: "FAQs",
    help: "Ajuda",
    frequently_asked_ques: "Perguntas Frequentes",
    customer_support: "Suporte ao cliente",
    user_name: "Nome de Usuário",
    password: "Senha",
    email_address: "Endereço de email",
    // Header Translations
    notification: "Notificação",
    page_loading_aria: "A página está carregando",
    state_loading_aria: "O estado está carregando",
    city_loading_aria: "A cidade está carregando",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Emblema geral",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Imagem do certificado",
    certificate_download: "Botão de download do certificado",
    prev: "Anterior",
    log_out: "Sair",
    // feature names
    feature_progress: "Progresso",
    feature_stressAndIntonation_title: "Estresse e entonação",
    feature_soundOfEnglish_title: "Sons do inglês",
    feature_vocabularyCenter_title: "Centro de vocabulário",
    feature_grammarCenter_title: "Centro de gramática",
    feature_culture_centre_title: "Centro de Cultura",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Feed da indústria",
    feature_newsfeed_title: "Feed de notícias",
    feature_emailTemplates_title: "Modelos de email",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Sotaques e dialetos",
    feature_writingCenter_title: "Centro de redação",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Sobre",
    legal: "Jurídico",
    privacy_policy: "Política de Privacidade",
    Terms_conditions: "Termos e condições",
    //button translations
    button_continue: "Continuar",
    button_KnowMore: "Saiba mais",
    button_BuyNow: "Compre agora",
    button_Subscribe: "Inscreva-se",
    button_GetStarted: "Iniciar",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "Ver detalhes",
    button_ContinueStudying: "Prosseguir",
    button_next: "Próximo",
    button_confirm: "Confirmar",
    // cookie policy
    common_cookiesPolicyText1:
      "A Learnship utiliza cookies a fim de garantir o melhor serviço possível. Ao permanecer no site, você concorda com o",
    common_cookiesPolicyText2: "uso de cookies",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Bem-vindo,",
    login_heloo: "Olá novamente",
    login_welcome_text: "Vamos começar",
    login_log_in: "Entrar",
    login_errorIncorrectCreds: "Nome de Usuário ou senha incorretos",
    login_errorContactAmin: "A sua conta não está ativa. Entre em contato com o administrador.",
    login_errorSSOuser: "Entre na sua conta através do portal de aprendizagem da sua empresa.",
    login_forgotPassword: "Esqueceu a senha?",
    login_resetPasswordTitle: "Redefinir senha",
    login_resetSuccess: "Enviamos um email contendo um link que permitirá que você redefina sua senha.",
    login_resetFailure: "O endereço de email está incorreto",
    // common translations
    message_errorDefault: "Algo está errado",
    message_successUpdated: "Atualizado com sucesso",
    message_unknownError: "Unknown error",
    message_unAuthorized: "Você não está autorizado",
    message_passwordUpdated: "Senha atualizada com sucesso",
    message_profileUpdated: "Perfil atualizado com sucesso",
    message_welcomeSubmitted: "Informações apresentadas com sucesso",
    message_samepasswordError:
      "Por favor, insira uma nova senha. Certifique-se de que não seja uma senha que já tenha sido utilizada.",
    SAR: "Selecione uma região",
    SAL: "Selecione uma localização",
    SAT: "Selecione um tópico",
    link_readmore: "Leia mais",
    //--//
    profile_title: "Perfil",
    profile_nameLabel: "Meu nome é: ",
    profile_countryLabel: "País",
    profile_stateLabel: "Estado / Província / Região",
    profile_cityLabel: "Cidade",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Método de contato preferido",
    profile_prefSkypeLabel: "ID do Skype (pessoal)",
    profile_prefMobileLabel: "Número de celular",
    profile_prefLandlineLabel: "Número de telefone fixo",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Eu aceito e concordo com o termos e condições",
    profile_continueAria: "Botão continuar",
    profile_TermsAria: "Aceitar termos e Condições",
    profile_stateTooltip: "Seu fuso horário nos ajudará a agendar suas sessões online.",
    profile_cityTooltip: "Se você não mora em uma das cidades mostradas aqui, escolha a mais próxima a você.",
    profile_emailTooltip: "Verifique seu email",
    profile_prefTooltip:
      "Todas as suas sessões ocorrerão na sala de aula virtual, mesmo que você tenha especificado um método de contato diferente no processo de integração. Perguntamos sobre seu método de contato preferido apenas para uso interno, para que possamos melhorar continuamente sua experiência de aprendizado.",
    profile_fnamePlaceholder: "Nome",
    profile_lnamePlaceholder: "Sobrenome",
    profile_countryPlaceholder: "Selecionar país",
    profile_prefContactSelect: "Selecione sua preferência",
    profile_statePlaceholder: "Selecione um Estado",
    profile_cityPlaceholder: "Selecione uma cidade",
    profile_emailInvalidMessage: "Endereço de email inválido",
    profile_prefContactPlaceholder: "Escolha sua preferência",
    profile_prefSkypePlaceholder: "Skype (pessoal)",
    profile_emailVerifiedChip: "Verificado",
    profile_emailVerifyChip: "Verificar",
    profile_emailpopup_head: "Digite o código de verificação",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Reenviar código",
    profile_emailpopup_resendMessage: "Não recebeu o código?",
    profile_invalidNumber: "Número inválido",
    profile_prefSkypeAria: "Contato preferido como ID do Skype (pessoal)",
    profile_prefMobileAria: "Contato preferido como celular",
    profile_prefLandlineAria: "Contato preferencial como telefone fixo",
    profile_emailpopup_incorrectCode: "Código inválido",
    profile_editLabel: "Editar Perfil",
    profile_editAria: "Botão Editar",
    profile_mainPasswordPlaceholder: "Digite a senha aqui",
    profile_updateLabel: "Atualizar",
    profile_welcomeJumbotron: "Fale sobre você.",
    profile_cancelLabel: "Cancelar",
    noAccessl1: "Ops! Você não tem permissão para visualizar esta página.",
    noAccessl2: "Aqui está um link para a",
    noAccessl2_1: "pagina inicial",
    noAccessl3: "Entre em contato com o administrador do Learnship para obter ajuda.",
    profile_license_information: "License information",
    profile_license_message: "Sua licença expira em",
    profile_changepass_changepassHead: "Mudar senha",
    profile_changepass_currentpassword: "Digite a senha atual",
    profile_changepass_currentpasswordPlaceholder: "Digite a senha atual",
    profile_changepass_newpassword: "Nova senha",
    profile_changepass_newpasswordPlaceholder: "Insira a nova senha",
    profile_changepass_confirmnewpassword: "Confirme a nova senha",
    profile_passMustInclude: "Sua senha deve atender aos seguintes requisitos:",
    profile_passdontmatch: "As senhas não coincidem",
    profile_incorrectPassword: "Senha incorreta",
    profile_passwordSubmit_title: "Digite a senha",
    profile_changepass_conditionLength: "Entre 8 a 32 caracteres",
    profile_changepass_conditionUppercase: "Pelo menos uma letra maiúscula",
    profile_changepass_conditionLowercase: "Pelo menos uma letra minúscula",
    profile_changepass_conditionSpecialCharacters: "Pelo menos um dígito ou um destes símbolos $! # & @?% * _",
    profile_translationLanguage: "Idioma de tradução",
    profile_translationLanguagePlaceholder: "Escolha um idioma",
    profile_managerEmailPlaceholder: "Email do gerente",
    profile_managerEmailpopupPlaceholder: "Email do gerente",
    // Learner Home Page translations
    learnerhome_survey_header: "Precisamos do seu feedback!",
    learnerhome_survey_line1: "Sua empresa deseja saber sobre a sua experiência no uso de nosso serviço.",
    learnerhome_survey_line2: "Por favor, complete a nossa pesquisa até",
    learnerhome_survey_line3: "Seu feedback é muito importante e muito apreciado.",
    learnerhome_survey_button1: "Responder à pesquisa",
    learnerhome_survey_button2: "Ignorar pesquisa",
    active_course: "Curso ativo",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Clique em um curso abaixo para começar.",
    product_solo_desc:
      "Learnship Solo nosso produto elearning, fornece tudo que os alunos precisam para praticar e melhorar seus habilidades linguísticas de negócios em seu próprio ritmo.",
    product_conversationPractice_desc:
      "Os alunos podem reservar sessões individuais com instrutores para fazer perguntas, discutir uma questão específica ou cenários de dramatização. Útil para alunos mais experientes que procuram refinar suas habilidades.",
    product_sprint_businessSkills_desc:
      "Este programa de aprendizagem combinada de última geração ajuda os alunos a desenvolver habilidades de negócios específicas, como apresentação de negócios, negociações, escrita de negócios e participação, em reuniões em tempo recorde.",
    product_sprint_levelsProgress_desc:
      "Nosso programa de aprendizagem combinada de última geração ajuda seu pessoal a melhorar de maneira mais rápida suas habilidades no idioma inglês quando comparado a um framework padronizado.",
    product_sprint_business_german_desc:
      "Nosso programa combinado de última geração ajuda seu pessoal a melhorar rapidamente suas habilidades em alemão em comparação a uma estrutura padronizada de ensino de idiomas.",
    product_sprint_business_french_desc:
      "Nosso programa combinado de última geração ajuda seu pessoal a melhorar rapidamente suas habilidades em francês em comparação a uma estrutura padronizada de ensino de idiomas.",
    product_sprint_business_spanish_desc:
      "Nosso programa combinado de última geração ajuda seu pessoal a melhorar rapidamente suas habilidades em espanhol em comparação a uma estrutura padronizada de ensino de idiomas.",
    product_evolve_relocationLanguage_desc:
      "Nosso programa de realocação de funcionários ajuda os alunos a desenvolver uma compreensão mais profunda do idioma e das nuances sociais de seu novo país de residência.",
    product_evolve_culturePowerSkills_desc:
      "Dê aos seus funcionários as habilidades interculturais de que precisam para prosperar em ambientes de trabalho internacionais e equipes virtuais globais.",
    product_evolve_cultureFocus_desc:
      "Treinamento específico do país e inteligência cultural para alunos que precisam obter uma melhor compreensão de uma região específica e sua cultura de trabalho.",
    product_evolve_cultureChange_desc:
      "Este é o nosso principal programa de treinamento de negócios interculturais para expatriados. Oferece aos alunos uma compreensão profunda do que é necessário para viver e trabalhar em uma nova cultura.",
    product_elevate_businessSkills_desc:
      "Módulos de treinamento curtos e padronizados para alunos de línguas que desejam aprimorar habilidades específicas de negócios, como apresentação, negociação ou liderança de equipe. Também oferecemos cursos especializados focados em dialetos específicos da indústria.",
    product_elevate_levelsProgress_desc:
      "Este curso de linguagem empresarial ministrado por um instrutor ajuda os alunos a melhorar suas habilidades escritas e verbais em uma estrutura padronizada.",
    product_coach_languageCoach_desc:
      "Comunique-se com confiança e clareza em salas de reuniões, emails, negociações e até mesmo durante a pausa do cafezinho. Nosso coaching individual e hiperespecífico de linguagem executiva ajuda você a dominar os cenários de negócios mais importantes. Desenvolva suas habilidades de comunicação verbal, escrita, de reunião e pessoal.",
    product_coach_cultureCoach_desc:
      "Um programa de coaching individual hiperfocado para executivos que buscam solucionar problemas específicos de comunicação intercultural.",
    product_solo_business_english:
      "Um programa de aprendizagem de vários níveis com exercícios online envolventes para desenvolver seu conhecimento e aplicação do inglês para negócios no seu próprio ritmo.",
    product_solo_business_german:
      "Um programa de aprendizagem de vários níveis com exercícios online envolventes para desenvolver seu conhecimento e aplicação do alemão para negócios no seu próprio ritmo.",
    product_solo_business_french:
      "Um programa de aprendizado de vários níveis com exercícios online envolventes para desenvolver seu conhecimento e aplicação do francês para negócios em seu próprio ritmo.",
    product_solo_business_spanish:
      "Um programa de aprendizagem de vários níveis com exercícios online envolventes para desenvolver seu conhecimento e aplicação do espanhol para negócios em seu próprio ritmo.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Esta é a sua porta de entrada para o Dashboard - uma interface intuitiva que permite aos administradores rastrear o uso, analisar o progresso do aluno, otimizar programas e avaliar o ROI.",
    product_elevate_desc:
      "O Elevate Business English é nosso treinamento presencial virtual para alunos que desejam melhorar sua proficiência lingüística geral trabalhando com um instrutor particular.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "Este rico programa de multimídia ajuda a sua equipe a melhorar rapidamente suas habilidades no idioma inglês com base em uma estrutura padronizada.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarize-se com as culturas das regiões que são importantes para seus negócios e vida profissional.",
    feature_emailTemplates_desc:
      "Os modelos de email cobrem uma ampla variedade de tópicos de negócios. Selecione o modelo que deseja e exporte-o diretamente para o seu email de trabalho, onde poderá editá-lo.",
    feature_newsFeed_desc:
      "Bem-vindo à nossa experiência revolucionária de notícias mundiais! Aprenda inglês por meio do conteúdo e das perguntas geradas ao vivo por nosso sistema de aprendizado.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "O feed da indústria combina uma biblioteca de artigos específicos da indústria com exercícios de linguagem baseados em IA. Escolha um artigo junto com um ponto de gramática que você deseja praticar.",
    feature_accentsAndDialects_desc:
      "Explore a riqueza do uso global do inglês por meio de nossa biblioteca de amostras de fala regionais.",
    feature_stressAndIntonation_desc:
      "Torne seu inglês mais natural e fácil de entender, aprendendo como usar a ênfase, o ritmo e a entonação corretos ao falar.",
    feature_soundOfEnglish_desc:
      "Melhore suas habilidades de comunicação aprendendo a pronunciar os sons em inglês corretamente.",
    feature_vocabularyCenter_desc:
      "Sem gramática, muito pouco pode ser transmitido. Sem vocabulário, nada pode ser transmitido. - David Wilkins",
    feature_grammarCenter_desc:
      "O centro de gramática o ajudará a usar a gramática correta ao falar e escrever. Inclui tópicos de gramática, como partes básicas de frases, verbos e formas verbais, e frases e orações.",
    feature_globalCommunityTutorials_desc:
      "Melhore suas habilidades no idioma inglês com esta coleção crescente de aulas desenvolvidas pela comunidade.",
    feature_toeic_desc:
      "O teste TOEIC® é o instrumento mais amplamente usado por empresas multinacionais para medir a proficiência em inglês dos funcionários. O TOEIC® usa materiais escritos e diálogos autênticos para avaliar suas habilidades de inglês para negócios.",
    feature_toefl_desc:
      "TOEFL®, o Teste de Inglês como Língua Estrangeira, é usado em todo o mundo por faculdades e universidades, agências governamentais e programas de bolsas de estudo para avaliar a proficiência em inglês.",
    feature_businessSituations_desc:
      "O Índice de Situações de Negócios facilita a localização de atividades específicas para que você possa se concentrar no idioma de que precisa para se comunicar em uma variedade de situações de negócios.",
    //carousel block translations
    title_feature: "Recursos",
    we_recommend: "Nós também recomendamos",
    // session report translations
    SessionReport_sessionReport: "Relatório de sessão",
    SessionReport_sessionDetails: "Detalhes",
    SessionReport_teacherName: "Nome do treinador",
    SessionReport_sessionReview: "Revisão da sessão",
    SessionReport_sessionFeedback: "Feedback da sessão",
    SessionReport_sessionMaterials_Assignments: "Materiais e tarefas da sessão",
    SessionReport_instructions: "Instruções",
    SessionReport_open: "Abrir",
    SessionReport_invalidSession_Message: "Desculpe, não há relatório para esta sessão.",
    SessionReport_rateSession: "Avalie sua sessão",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "Como foi sua sessão com",
    SessionRating_sessionDate: "Data da sessão",
    SessionRating_sessionTime: "Tempo de sessão",
    SessionRating_sessionDuration: "Duração da sessão",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Avalie sua experiência",
    SessionRating_whatWentWrong: "O que deu errado?",
    SessionRating_content: "Conteúdo",
    SessionRating_technology: "Tecnologia",
    SessionRating_comment: "Deixe um comentário",
    SessionRating_submit: "Enviar",
    SessionRating_remindMeLater: "Lembrar depois",
    SessionRating_close: "Fechar",
    SessionRating_completed: "Concluído",
    sessionRating_sessionDetails_mins: "Minutos",
    // my schedule page translations
    myschedule_availability_abty_given: "Estamos trabalhando para combiná-lo com um instrutor.",
    myschedule_schedule: "Meu horário",
    myschedule_availability_needAvl: "Precisamos de sua disponibilidade para agendar a sessão.",
    myschedule_availability_abty_not_given: "Forneça / modifique sua disponibilidade",
    myschedule_statusCard_completed: "Sessões concluídas",
    myschedule_statusCard_remaining: "Sessões restantes",
    myschedule_statusCard_scheduled: "Sessões a serem agendadas",
    myschedule_statusCard_lost: "Sessões perdidas (cancelada sem antecedência e ausente)",
    myschedule_recentUpcoming_courseName: "Nome do curso",
    myschedule_next_session: "Próxima sessão",
    myschedule_session_topic: "Tópico da Sessão",
    myschedule_sessionDetails_communication: "Comunicação",
    myschedule_sessionDetails_allSessions: "Todas as sessões",
    myschedule_sessionDetails_upcomingSessions: "Próximas sessões",
    myschedule_sessionDetails_pastSessions: "Sessões anteriores",
    myschedule_sessionDetails_teacher_name: "Instrutor",
    myschedule_sessionDetails_sessions: "Número",
    myschedule_sessionDetails_date: "Data",
    myschedule_sessionDetails_time: "Tempo",
    myschedule_sessionDetails_durationText: "Duração",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Como reagendar sua sessão",
    myschedule_reschedule_InstrBegin: "Veja como você pode reagendar suas sessões com seu instrutor",
    myschedule_reschedule_instr1a: "Verifique os detalhes da sessão no topo",
    myschedule_reschedule_instr1b: "A data e hora da sua sessão são mostradas na parte superior.",
    myschedule_reschedule_instr2: "A disponibilidade do instrutor é exibida em verde",
    myschedule_reschedule_instr3:
      "Você poderá ver a disponibilidade do seu instrutor. Os horários disponíveis são indicados em verde.",
    myschedule_reschedule_instr4: "Selecione um horário para reprogramar",
    myschedule_reschedule_instr5:
      "Para reagendar, clique na área verde de horários disponíveis para o horário escolhido.",
    myschedule_reschedule_next_instr1: "Sem horário adequado",
    myschedule_reschedule_next_instr2:
      "Tente evitar cancelamentos, se você realmente não conseguir encontrar um horário adequado com o seu instrutor, use o botão “Sem horário adequado” para cancelar a sua sessão. Nesse caso, o seu instrutor agendará esta sessão para você ou um administrador o ajudará.",
    myschedule_reschedule_next_instr3: "Mude o seu instrutor",
    myschedule_reschedule_next_instr4a:
      "Para mudar o seu instrutor para uma ou mais das suas sessões restantes, use o nosso",
    myschedule_reschedule_next_instr4b: "formulário de contato",
    myschedule_reschedule_next_instr4c:
      "e selecione <ProductName> + 'Mudar de instrutor' Por favor, forneça um motivo pelo qual você gostaria de mudar de instrutor.",
    myschedule_rechedule_next_info:
      "Para mais informações sobre as opções de reagendamento e cancelamento, visite a nossa página de",
    myschedule_rechedule_next_faq: "Perguntas Frequentes.",
    myschedule_rechedule_next_noShow: "Não mostre esta página de informações novamente",
    myschedule_rechedule_next_done: "Concluído",
    myschedule_rechedule_skipButton: "Pular",
    myschedule_upcoming_joinNow: "Entrar agora",
    myschedule_cancel_question: "Tem certeza de que deseja cancelar esta sessão?",
    myschedule_cancel_button: "Cancelar sessão",
    myschedule_cancel_no: "Não",
    myschedule_invalid_session: "Desculpe, esta é uma sessão inválida ",
    myschedule_sessionDuraion_minutes: "Minutos",
    myschedule_homepage_view: "Ver",
    myschedule_finished_status: "Concluído",
    myschedule_reschedule_button: "Reagendar",
    myschedule_addToCalendar_instr1: "Clique no",
    myschedule_addToCalendar_instr2:
      "botão de download para obter sua programação da Learnship. Você pode então adicioná-la ao seu calendário pessoal.",
    myschedule_addToCalendar_instr3:
      "Se você já havia adicionado um cronograma da Learnship ao seu calendário, certifique-se de excluir o existente primeiro.",
    myschedule_addToCalendar_instr4:
      "Saiba mais sobre como adicionar a programação da Learnship ao seu calendário pessoal",
    myschedule_addToCalendar_instr5: "aqui",
    myschedule_no_teacher_title: "Nenhum professor designado",
    myschedule_no_teacher_body:
      "Nenhuma sessão pode ser adicionada no momento (nenhum professor designado). Entre em contato com coach@globalenglish.com para continuar com seu programa.",
    myschedule_no_sessions: "Nenhuma sessão encontrada",
    myschedule_no_upcoming_sessions: "Nenhuma sessão futura encontrada",
    myschedule_no_past_sessions: "Nenhuma sessão passada encontrada",
    myschedule_status_lost: "Perdida",
    myschedule_status_finished: "Concluída",
    myschedule_status_completed: "Concluído",
    myschedule_status_cancelled: "Cancelada",
    myschedule_status_inprogress: "Em andamento",
    myschedule_status_pending: "Pendente",
    myschedule_status_active: "Ativo",
    myschedule_status_inplanning: "Em planejamento",

    // my schedule page translations end
    // Progress page
    progress_title: "Meu progresso",
    progress_activity_report: "Relatório de atividade",
    progress_test_results: "Resultado dos testes",
    progress_productname_sprint_skills: "Habilidades do Sprint",
    progress_productname_reach_skills: "Habilidades do Reach",
    progress_skill_note:
      "Você deve concluir 70% ou mais dos cursos e sessões para ter direito a um certificado de conclusão.",
    progress_overall_card_title_prework: "Exercícios preparatórios concluídos",
    progress_overall_card_title_homework: "Tarefa de casa concluída",
    progress_overall_card_title_session: "Sessões concluídas",
    progress_overall_card_title_certificate: "Certificado",
    progress_overall_card_title_skillsCompleted: "Competências concluídas",
    progress_overall_card_title_badgesEarned: "Medalhas conquistadas",
    progress_overall_card_title_missionsPassed: "Missões aprovadas",
    progress_overall_card_title_timeInReach: "Tempo no Reach (HH:MM)",
    progress_noSubskill: "Não há habilidade para mostrar.",
    progress_tab_nodata: "Não há dados para mostrar aqui.",
    progress_percentCompleted: "porcentagem concluída",
    progress_subskill_preworkTitle: "Trabalho de Preparação",
    progress_subskill_homeworkTitle: "Tarefa de casa",
    progress_subskill_sessionTitle: "Sessão",
    progress_subskill_sessionStatusCompleted: "Concluído",
    progress_subskill_sessionStatusNotCompleted: "Não concluído",
    progress_subskill_sessionStatusNoSessions: "Sem sessões",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Tempo total",
    progress_activity_tooltip_activitiesCompleted: "Atividades concluídas",
    progress_activity_tooltip_reachMissionsCompleted: "Missões do Reach concluídas ",
    progress_activity_tooltip_timeinhhmm: "Tempo em HH: MM",
    progress_activity_tabDaily: "Diário",
    progress_activity_tabWeekly: "Semanal",
    progress_activity_tabMonthly: "Mensal",
    progress_activity_tabQuarterly: "Trimestral",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Anual",
    progress_acitivity_Minutes: "Minutos",
    progress_acitivity_legend_selfpaced: "Tempo de aprendizagem individualizado",
    progress_acitivity_legend_trainerLed: "Tempo de preparação do instrutor",
    progress_acitivity_legend_recommended: "Recomendado",
    progress_testresults_table_testname: "Nome de teste",
    progress_testresults_table_scores: "Notas",
    progress_testresults_table_date: "Data",
    progress_testresults_info: "Os resultados dos seus testes serão exibidos em 24 horas.",
    progress_inprogress: "Em andamento",
    progress_totalscore: "Pontuação total",
    progress_placedText: "Posição",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Parte",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title:
      "Para receber um certificado de conclusão, exigimos o cumprimento de 70% dos exercícios digitais.",
    progress_badge_dialog_box_golden: "Uma pontuação de sucesso de 80% dá direito a um distintivo de ouro",
    progress_badge_dialog_box_silver: "Uma pontuação de sucesso entre 70% e 79% dá direito a um distintivo de prata",
    progress_badge_dialog_box_bronze: "Uma pontuação de sucesso entre 50% a 69% ganha um distintivo de bronze",
    progerss_badge_dailog_box_digitalActivities:
      "A pontuação de sucesso é calculada com base no seu desempenho e envolvimento com as atividades digitais online",
    progress_badge_dailog_box_liveSessions:
      "A pontuação de sucesso é calculada com base no seu desempenho e envolvimento com as atividades digitais online e sessões ao vivo",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    //Email Templates
    wcTitle: "Centro de Redação",
    guidelines: "Diretrizes para Redação",
    sampleDocs: "Exemplos de documentos",
    languageSelect: "Select a language",
    wcGroup1: "Pedidos de desculpas",
    wcGroup2: "Reclamações",
    wcGroup3: "Elogios",
    wcGroup4: "Parabenização",
    wcGroup5: "Documentos",
    wcGroup6: "Convites",
    wcGroup7: "Formulários de solicitação de emprego",
    wcGroup8: "Marketing e vendas",
    wcGroup9: "Reuniões",
    wcGroup10: "Avisos",
    wcGroup11: "Pedidos",
    wcGroup12: "Informações sobre preços",
    wcGroup13: "Solicitações",
    wcGroup14: "Agradecimentos",
    wcTitle11: "Pedido de desculpas por atraso em projeto",
    wcTitle12: "Pedido de desculpas por erro em conta",
    wcTitle13: "Pedido de desculpas por atraso na entrega",
    wcTitle14: "Pedido de desculpas por entrega de mercadoria danificada",
    wcTitle15: "Pedido de desculpas por faltar a uma reunião",
    wcTitle21: "Reclamação em geral",
    wcTitle22: "Reclamação sobre problema com um produto",
    wcTitle23: "Reclamação sobre cobrança indevida em conta",
    wcTitle31: "Elogio a um projeto de um colega",
    wcTitle32: "Elogio sobre o serviço de atendimento ao consumidor",
    wcTitle33: "Elogio a um produto",
    wcTitle41: "Parabenização por uma promoção (formal)",
    wcTitle42: "Parabenização por uma promoção (informal)",
    wcTitle43: "Parabenização por um acontecimento pessoal",
    wcTitle51: "Solicitação de documento",
    wcTitle52: "Formulário de pedido ou pedido de compra",
    wcTitle53: "Fatura",
    wcTitle61: "Convite para um evento pessoal",
    wcTitle62: "Convite a um evento de negócios",
    wcTitle63: "Aceitação de um convite",
    wcTitle64: "Recusa de convite",
    wcTitle65: "Cancelamento de evento de negócios",
    wcTitle71: "Notificação de recebimento de solicitação",
    wcTitle81: "Aviso de lançamento de novo produto",
    wcTitle82: "Aviso sobre novo representante de área",
    wcTitle83: "Demonstração de novo produto",
    wcTitle84: "Mudança de endereço de cobrança",
    wcTitle85: "Acompanhamento após a primeira reunião de vendas",
    wcTitle86: "Boas-vindas a novo cliente",
    wcTitle87: "Mensagem de feriado para acionistas ou clientes",
    wcTitle91: "Sugestão de horário para reunião",
    wcTitle92: "Confirmação de reunião",
    wcTitle93: "Adiamento de reunião",
    wcTitle94: "Cancelamento de reunião",
    wcTitle95: "Resumo de reunião",
    wcTitle101: "Suspensão de conta",
    wcTitle102: "Pedido de fechamento de conta",
    wcTitle111: "Confirmação de pedido",
    wcTitle112: "Confirmação de envio de mercadoria",
    wcTitle113: "Cancelamento de pedido",
    wcTitle114: "Alteração de pedido",
    wcTitle115: "Notificação de recebimento",
    wcTitle121: "Envio de informações sobre preços",
    wcTitle122: "Aceitação de cotação de preço",
    wcTitle123: "Recusa de cotação de preço",
    wcTitle131: "Pedido para esclarecimento de informações",
    wcTitle132: "Pedido de informações sobre produto",
    wcTitle133: "Pedido de informações sobre serviço",
    wcTitle141: "Agradecimentos em geral",
    guideGroup1: "Problemas comuns de redação",
    guideGroup2: "Comunicação geral de negócios",
    guideGroup3: "Documentos de negócio",
    guideTitle11: "Razões para redação sem clareza",
    guideTitle12: "Erros básicos de redação",
    guideTitle13: "Problemas com verbos",
    guideTitle21: "Franqueza na comunicação de negócios",
    guideTitle22: "Linguagem para vendas e marketing",
    guideTitle23: "Expressões de negócios cotidianas",
    guideTitle31: "Emails eficientes",
    guideTitle32: "Apresentações: Dicas gerais",
    guideTitle33: "Apresentações: Aberturas marcantes",
    backIndex: "Voltar para o índice",
    copyText: "Copiar texto",
    exportEmail: "Exportar texto para email",
    beActivity: "Nível de Inglês Comercial <course>, Tarefa <assign>, Atividade <act>",
    Blob:
      "Os modelos de e-mail abrangem uma ampla variedade de assuntos sobre o mundo dos negócios. Escolha o modelo desejado e exporte-o diretamente para seu e-mail para editá-lo e enviá-lo.",
    OpenInEmail: "Abrir no e-mail",
    Quote1: "Existem 3,3 bilhões de contas de e-mail no mundo.",
    Quote1By: "Mashable",
    Quote2: "O e-mail gera cerca de o dobro de retorno dos outros canais.",
    Quote2By: "Líder de Marketing Direto",
    Quote3: "3,5 milhões de e-mails são enviados por segundo.",
    Quote3By: "Marketing Direto",
    SelectACategory: "Selecione uma categoria",
    Title: "Modelos de e-mail",
    WatchTutorial: "Assista ao tutorial em vídeo",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "América do Norte",
    Cenam: "América Central",
    SoAm: "América do Sul",
    EUR: "Europa",
    ASIA: "Ásia",
    CenASIA: "Ásia Central",
    SoEASIA: "Sudeste da Ásia",
    MidEAST: "Oriente Médio ",
    AFR: "África",
    AUST: "Austrália",
    Cana: "Canadá",
    Mexi: "México",
    Uniteds: "Estados Unidos",
    CostaR: "Costa Rica",
    DomRep: "República Dominicana",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panamá",
    TriniTob: "Trinidad e Tobago",
    Arge: "Argentina",
    Braz: "Brasil",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Colômbia",
    Peru: "Peru",
    Urug: "Uruguai",
    Austria: "Áustria",
    Belg: "Bélgica",
    Bulg: "Bulgária",
    Croatia: "Croácia",
    Czec: "República Tcheca",
    Denm: "Dinamarca",
    Finl: "Finlândia",
    Fran: "França",
    Germ: "Alemanha",
    Greec: "Grécia",
    Hung: "Hungria",
    Icel: "Islândia",
    Irel: "Irlanda",
    Ital: "Itália",
    Lith: "Lituânia",
    Luxem: "Luxemburgo",
    Neth: "Holanda",
    Norw: "Noruega",
    Pola: "Polônia",
    Port: "Portugal",
    Roma: "Romênia",
    Russ: "Rússia",
    Serb: "Sérvia",
    Slovakia: "Eslováquia",
    Slovania: "Eslovênia",
    Spai: "Espanha",
    Swed: "Suécia",
    Swit: "Suíça",
    Turk: "Turquia",
    Ukra: "Ucrânia",
    Unitedk: "Reino Unido",
    Chin: "China",
    Hong: "Hong Kong",
    Indi: "Índia",
    Japa: "Japão",
    Mongo: "Mongólia",
    Pakis: "Paquistão",
    SoKore: "Coreia do Sul",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afeganistão",
    Azer: "Azerbaijão",
    Kaza: "Cazaquistão",
    Camb: "Camboja",
    Indo: "Indonésia",
    Malay: "Malásia",
    Phil: "Filipinas",
    Sing: "Cingapura",
    Thai: "Tailândia",
    Viet: "Vietnã",
    Bah: "Bahrain",
    Iran: "Irã",
    Iraq: "Iraque",
    Isra: "Israel",
    Jor: "Jordânia",
    Kuw: "Kuwait",
    Leb: "Líbano",
    Oma: "Omã",
    Qat: "Catar",
    SauArb: "Arábia Saudita",
    UAE: "Emirados Árabes Unidos",
    Alger: "Argélia",
    Angol: "Angola",
    Egyp: "Egito",
    Ghana: "Gana",
    Guin: "Guiné",
    Keny: "Quênia",
    Malaw: "Malaui",
    Moroc: "Marrocos",
    Mozam: "Moçambique",
    Nige: "Nigéria",
    SoAfr: "África do Sul",
    Tanz: "Tanzânia",
    Ugan: "Uganda",
    Zamb: "Zâmbia",
    Austra: "Austrália",
    NewZea: "Nova Zelândia",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Familiarize-se com as culturas das regiões que são importantes para seus negócios e vida profissional.",
    culturenotes_useculturalinfo:
      "Use nossas informações culturais para se preparar para reuniões importantes com clientes e colegas de trabalho em todo o mundo.",
    culturenotes_topicfamiliarize:
      "Familiarize-se com os costumes (horário comercial, ambientes de trabalho, etc.), como são os jantares, a etiqueta para presentear alguém, etc., em outras culturas.",
    culturenotes_topiclearnculture:
      "Saiba mais sobre as práticas e diferenças culturais, além dos costumes locais para evitar as gafes.",
    culturenotes_tmaworldtext:
      "Relatórios sobre países são desenvolvidos por nossa parceira TMA World , e estão disponíveis para download em versões em PDF.",
    culturenoteslocation_viewbytopic: "Visualizar por tópico",
    culturenoteslocation_viewbycountry: "Visualizar  por país",
    culurecenter_disclaimer_title: "Isenção de responsabilidade",
    culturecenter_disclaimer:
      "or favor, trate as informações que você vai ler como um guia geral, que deve ser um ponto de partida para se familiarizar com uma nova cultura. Esta ferramenta irá ajudá-lo a aprender sobre padrões culturais comuns, o que servirá como base para melhor compreender e interpretar as diferenças culturais no comportamento, atitudes e reações das pessoas. No entanto, é importante ter em mente que as características comuns de uma determinada cultura variam regionalmente e por personalidade individual.​​",
    culturecenter_intercept_title: "O Centro de Cultura está de volta!​​",
    culturecenter_intercept_text1:
      "Depois de alguns retoques, temos o prazer de anunciar que o Centro de Cultura está de volta!",
    culturecenter_intercept_text2:
      "Com o Centro de Cultura, você aprende mais sobre as práticas e costumes profissionais em 20 países ao redor do mundo, incluindo EUA, Canadá, México, China, Japão, Índia e muitos outros...",
    culturecenter_intercept_direct: "Ir para o Centro de Cultura​",
    dailyNewsFeed_resources: "Recursos",
    dailyNewsFeed_daily_News: "Feed de notícias diárias",
    dailyNewsFeed_newsfeedoftheday: "Feed de notícias do dia",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Desculpe, não foi possível obter o seu feed de notícias, tente novamente mais tarde.",
    dailyNewsFeed_viewMoreCategories: "Veja mais",
    // Email templates end
    //Error Page Translations
    error_not_found: "Ops! Página não encontrada.",
    error_contact_csm: "Entre em contato com o gerente de sucesso do cliente para obter ajuda.",
    error_under: "Em",
    error_maintenance: "Manutenção",
    error_under_maintenance: "Nosso site está em manutenção programada.",
    error_inconvenience: "Pedimos desculpas por qualquer inconveniente.",
    error_tryagain: "Por favor, tente novamente mais tarde.",
    error_tryagainMins: "Por favor tente novamente em",
    error_minutes: "minuto(s)",
    error_hours: "hora(s)",
    error_oops: "Ops!",
    error_permission_denied: "Você não tem permissão para visualizar esta página!",
    error_link_home: "pagina inicial",
    error_contact_admin:
      "Entre em contato com o administrador da <donottrans> Learnship </donottrans> para obter ajuda.",
    error_sorry: "Desculpe-nos.",
    error_load: "There was a problem loading this Page.",
    error_clear_cache: "Limpe o cache do navegador, verifique as conexões com a Internet e tente novamente.",
    error_contact: "Entre em contato com a nossa",
    error_contact_cst: "equipe de suporte ao cliente",
    error_forhelp: "para solicitar ajuda.",
    error_having_trouble: "Ainda está tendo problemas?",
    //Accents and Dialects Dropdowns
    AF: "África",
    AS: "Ásia",
    AU: "Austrália-Oceania",
    CA: "Caribe",
    CE: "América central",
    EU: "Europa",
    MI: "Oriente médio",
    NO: "América do norte",
    SO: "América do sul",
    CAMER: "República de Camarões",
    EGYPT: "Egito",
    ETHIO: "Etiópia",
    GHANA: "Gana",
    GUINE: "Guiné",
    NIGER: "Nigéria",
    SOUTH: "África do Sul",
    TANZA: "Tanzânia",
    AFGHA: "Afeganistão",
    CHINA: "China",
    INDIA: "Índia",
    INDON: "Indonésia",
    JAPAN: "Japão",
    KAZAK: "Casaquistão",
    LEBAN: "Líbano",
    MONGO: "Mongólia",
    NORTH: "Vietnã do Norte",
    PAKIS: "Paquistão",
    PHILI: "Filipinas",
    SINGA: "Cingapura",
    KOREA: "Coréia",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwan",
    THAIL: "Tailândia",
    TURKM: "Turcomenistão",
    AUSTR: "Austrália",
    FIJI_: "Fiji",
    NEW_Z: "Nova Zelândia",
    BERMU: "Bermudas",
    CUBA_: "Cuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (Francesa)",
    TRINI: "Trinidad e Tobago",
    AUSTRI: "Áustria",
    BELAR: "Bielorrússia",
    BELGI: "Bélgica",
    BULGA: "Bulgária",
    CYPRU: "Chipre",
    CZECH: "República Tcheca",
    DENMA: "Dinamarca",
    ENGLA: "Inglaterra",
    FINLA: "Finlândia",
    FRANC: "França",
    GEORG: "Geórgia",
    GERMA: "Alemanha",
    GREEC: "Grécia",
    HUNGA: "Hungria",
    IRELA: "Irlanda",
    ITALY: "Itália",
    MACED: "Macedônia do Norte",
    NETHE: "Países Baixos",
    NORTHI: "Irlanda do norte",
    POLAN: "Polônia",
    ROMAN: "Romênia",
    RUSSI: "Federação Russa",
    SCOTL: "Escócia",
    SPAIN: "Espanha",
    SWEDE: "Suécia",
    SWITZ: "Suíça",
    TURKE: "Turquia",
    UKRAI: "Ucrânia",
    WALES: "País de Gales",
    IRAN_: "Irã",
    IRAQ_: "Iraque",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Arábia Saudita",
    SYRIA: "Síria",
    CANAD: "Canadá",
    MEXIC: "México",
    ARGEN: "Argentina",
    BRAZI: "Brasil",
    CHILE: "Chile",
    COLOM: "Colômbia",
    PARAG: "Paraguai",
    PERU_: "Peru",
    VENEZ: "Venezuela",
    RPTitle: "Passagem do texto do arco-íris",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Sotaques e dialetos",
    US: "Estados Unidos da América",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "Califórnia",
    FLORI: "Flórida",
    GEORG_US: "Geórgia",
    HAWAI: "Havaí",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "Nova Jérsei",
    NEW_Y: "Nova Iorque",
    NCARO: "Carolina do norte",
    NDAKO: "North Dakota",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvania",
    SOUTH_US: "Carolina do sul",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virgínia",
    WEST_: "Virgínia do Oeste",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "Sua empresa solicitou um relatório mensal para o seu gerente indicando o seu progresso na Learnship. Forneça o email do seu gerente abaixo.",
    // survey and notification
    notification_description_plural:
      "{days} dias restantes para completar a pesquisa. Você deve concluí-la até {date}.",
    notification_description_singular: "1 dia restante para completar a pesquisa. Você deve concluí-la até {date}.",
    notification_maintenance_message: "Halo estará em manutenção programada em {date} às {time}.",
    //renewal
    renewal_welcome: "Bem-vindo de volta ao Learnship!",
    renewal_text:
      "Sua licença do Learnship expirará em {date} de {month} de {year}. Para continuar a melhorar as suas habilidades em comunicação comercial em inglês, renove a sua licença hoje. O seu plano de estudos e todo o seu trabalho serão salvos e você continuará no seu nível atual.",
    renewal_later: "Pergunte-me mais tarde.",
    renewal_affirmative: "Eu quero renovar a minha licença.",
    renewal_negative: "Eu não quero renovar a minha licença.",
    renewal_yes: "SIM",
    renewal_no: "NÃO",
    courselevel: "Nível do curso",
    currentunit: "Unidade atual",
    upcomingsession: "Próximas",
    viewschedule: "View Schedule",
    currentskills: "Habilidades",
    currentsubskills: "Sub-habilidades",
    // TWT translations
    twt_talk_with_teacher_title: "Converse com o Professor",
    twt_sub_heading: "Pratique suas habilidades de conversação com um professor e outros alunos em sua aula on-line!",
    twt_select_sessions: "Selecione suas sessões:",
    twt_view_schedule_title: "ver a programação e adicionar ao calendário",
    twt_next_week: "Assunto da semana que vem:",
    twt_previous_week: "semana anterior",
    twt_add_to_calendar: "Adicionar ao calendário",
    twt_view_more: "Veja mais",
    twt_topic: "Tópico",
    twt_class_policy_title: "Políticas e Diretrizes do Conversa com o Professor",
    twt_class_policy_subHeading:
      "As políticas e diretrizes a seguir são importantes para garantir que sua experiência na sessão de Conversa com o Professor seja educativa e agradável. Por favor, leia-as com atenção.",
    twt_class_policy_list01:
      "Você pode participar de uma sessão por semana*. Nossas salas de aula on-line têm um limite de oito alunos. Estar pronto para o início da sessão. As salas de Conversa Com o Professor (TWT) são acessíveis apenas durante os primeiros 10 minutos de cada sessão. Por exemplo, uma sessão que começa às 9:00 está acessível até às 9:10. Após os primeiros 10 minutos, você não poderá ingressar na sessão.*O acesso limitado ou não ilimitado depende do tipo de licença que você possui.",
    twt_class_policy_list02_sub1:
      "Quando você entrar na sala de aula, digite seu nome, cidade, país e nível na caixa de bate-papo.",
    twt_class_policy_list02_sub2: `Por exemplo, "Meu nome é Leão e sou de São Paulo, Brasil. Estou no Nível 6."`,
    twt_class_policy_list02_sub3: "O instrutor irá então ativar o seu microfone e o ícone do microfone aparecerá.",
    twt_class_policy_list03:
      "Se você tiver um problema técnico, entre em contato com o Suporte ao Cliente. Clique em <b>Ajuda -Help-</b> na parte superior da página para enviar o problema por escrito ou fale com um representante do Suporte ao Cliente usando a ferramenta Bate-papo -Chat- encontrada em qualquer página do Learnship One. Por favor, não peça ajuda técnica ao professor.",
    twt_class_policy_list04:
      "Existem quatro níveis de sessão do Conversa Com o Professor (TWT): Iniciante, Intermediário, Avançado e Todos os Níveis. Você deve ir a uma sessão que seja apropriada para sua habilidade em inglês. Por exemplo, se você estiver nos Níveis 0-3, deverá ir para uma sessão Iniciante. Qualquer aluno (em qualquer nível) pode participar das sessões de Todos os Níveis. Se você participar de uma sessão de Conversa com o Professor que não seja apropriada para o seu inglês, seu instrutor informará que você não está na sessão correta. Você terá duas opções: você pode dizer ao instrutor que gostaria de ficar e ouvir apenas, ou seja, você não pode participar (falar); ou você pode sair e entrar em outra sessão no nível correto em outro momento.",
    twt_class_policy_list05:
      "Se você gostaria de ouvir uma sessão online sem falar, você pode fazê-lo por uma hora por semana. Depois disso, você deve participar falando durante a sessão. Você pode ouvir sem falar por um total de quatro sessões por ano. Se você ultrapassar esses limites e não começar a participar (falar) na sessão, sua sessão terminará.",
    twt_class_policy_list06:
      "Não toleraremos linguagem obscena ou ofensiva em inglês ou em qualquer outro idioma. Se você violar esta política, nós imediatamente removeremos você da sessão. Notificaremos seu gerente sobre seu comportamento ofensivo e poderemos encerrar sua conta.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message:
      "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
    twt_notification_message: "Há uma sessão de conversa começando agora. Você quer se juntar?",
    twt_limit_message: "Você já participou de uma classe esta semana.",
    twt_session_unavailable: "Sem sessões disponíveis",
    twt_select_language: "Selecione o idioma",

    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_no_wordlist_message: "Oops! There are no wordslist in {wordListName}. Add new wordslist!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",

    // Stress and inotation translations
    stress_intonation_product_headline: "StressAndIntonation",
    stress_intonation_product_description:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",

    // Sounds of English translations
    soe_product_headline: "Sounds of English",
    soe_product_description: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    soe_product_vowels: "Vowels",
    soe_product_consonants: "Consonants",
    soe_product_language_selection:
      "Select your language in the drop-down list to find the sounds that may be difficult for speakers of your language. Then select My Sounds to find the sounds that you had trouble with in the Pronunciation Practice and Communication Practice activities.",

    // Writing center
    wc_feature_headline: "Centro de Redação",
    wc_feature_description: "Level up your professional writing ability via our targeted resources.",
    wc_feature_guideGroup1: "Problemas comuns de redação",
    wc_feature_guideGroup2: "Comunicação geral de negócios",
    wc_feature_guideGroup3: "Documentos de negócio",
    wc_feature_guideTitle11: "Razões para redação sem clarezag",
    wc_feature_guideTitle12: "Erros básicos de redação",
    wc_feature_guideTitle13: "Problemas com verbos",
    wc_feature_guideTitle21: "Franqueza na comunicação de negócios",
    wc_feature_guideTitle22: "Linguagem para vendas e marketing",
    wc_feature_guideTitle23: "Expressões de negócios cotidianas",
    wc_feature_guideTitle31: "Emails eficientes",
    wc_feature_guideTitle32: "Apresentações: Dicas gerais",
    wc_feature_guideTitle33: "Apresentações: Aberturas marcantes",
  },
};
